import { GridType } from '@app/pcs/models';
import { GridConfigBuilder, SelectionType } from 'ngrx-data-grid';

export const REFERENCE_DATA_GRID_TYPE = GridType.Display;
export const REFERENCE_DATA_GRID_CONFIGURATION = GridConfigBuilder.gridConfig()
  .withSelection(SelectionType.Checkbox)
  .withStickyHeader(true)
  .withColumnResize()
  .withColumnReorder()
  .build();
